var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustAiTransparencyCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20l-3.8-3.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8v3l2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustAiTransparencyCyan);
export default __webpack_public_path__ + "static/media/trust-ai-transparency-cyan.c2dfd80719814549e81f8aa5eaa97a9e.svg";
export { ForwardRef as ReactComponent };